import { ApiPetType } from '@/core/generated/api';

export const PRODUCT_TYPES = {
    subscription: 'subscription',
    dogWalking: 'dogWalking',
    petBoarding: 'petBoarding',
    petSitting: 'petSitting',
    toSpecialist: 'toSpecialist',
    additionalService: 'additionalService',
} as const;

export const PRODUCT_TYPES_OPTIONS = [
    {
        id: PRODUCT_TYPES.subscription,
        name: 'Абонемент'
    },
    {
        id: PRODUCT_TYPES.dogWalking,
        name: 'Выгул'
    },
    {
        id: PRODUCT_TYPES.petBoarding,
        name: 'Передержка'
    },
    {
        id: PRODUCT_TYPES.petSitting,
        name: 'Няня'
    },
    {
        id: PRODUCT_TYPES.toSpecialist,
        name: 'Поход к специалисту'
    },
    {
        id: PRODUCT_TYPES.additionalService,
        name: 'Дополнительная услуга'
    },
];

export const PRODUCT_SUB_TYPES = {
    longWalk: 'longWalk',
    imNotHome: 'imNotHome',
} as const;

export const PRODUCT_SUB_TYPES_OPTIONS = [
    {
        id: PRODUCT_SUB_TYPES.longWalk,
        name: 'Долгая прогулка'
    },
    {
        id: PRODUCT_SUB_TYPES.imNotHome,
        name: 'Меня не будет дома'
    },
];

export const PET_TYPES = {
    dog: 'dog',
    cat: 'cat',
    other: 'other',
} as const;

export const PET_TYPES_OPTIONS = [
    {
        id: PET_TYPES.dog,
        name: 'Собаки'
    },
    {
        id: PET_TYPES.cat,
        name: 'Кошки'
    },
    {
        id: PET_TYPES.other,
        name: 'Остальные'
    },
];

/** Виды питомцев для услуг и заказов, включая совместное обслуживание */
export const SERVICE_PET_TYPES_OPTIONS = [
    ...PET_TYPES_OPTIONS,
    {
        id: ApiPetType.Mixed,
        name: 'Разные виды питомцев'
    },
];

export const MONEY_DEBIT_TYPES = {
    perDay: 'perDay',
    perService: 'perService',
    perServiceWithAnimalCount: 'perServiceWithAnimalCount',
} as const;

export const MONEY_DEBIT_TYPES_OPTIONS = [
    {
        id: MONEY_DEBIT_TYPES.perDay,
        name: 'За каждый день'
    },
    {
        id: MONEY_DEBIT_TYPES.perService,
        name: 'За услугу'
    },
    {
        id: MONEY_DEBIT_TYPES.perServiceWithAnimalCount,
        name: 'За услугу (с учетом кол-ва животных)'
    },
];

export const GENDERS = {
    male: 'male',
    female: 'female',
} as const;

export const GENDERS_OPTIONS = [
    {
        id: GENDERS.male,
        name: 'Мужской'
    },
    {
        id: GENDERS.female,
        name: 'Женский'
    },
];

export const ORDER_STATUS = {
    draft: 'draft',
    assigned: 'assigned',
    inProgress: 'inProgress',
    completed: 'completed',
    cancelled: 'cancelled',
    requestPending: 'requestPending',
    searchable: 'searchable',
    sentToSignDocuments: 'sentToSignDocuments',
    executorApproved: 'executorApproved',
} as const;

export const ORDER_STATUS_OPTIONS = [
    {
        id: ORDER_STATUS.draft,
        name: 'Черновик'
    },
    {
        id: ORDER_STATUS.assigned,
        name: 'Исполнитель назначен'
    },
    {
        id: ORDER_STATUS.inProgress,
        name: 'Исполнитель начал выполнение'
    },
    {
        id: ORDER_STATUS.completed,
        name: 'Заказ завершён'
    },
    {
        id: ORDER_STATUS.cancelled,
        name: 'Заказ отменён'
    },
    {
        id: ORDER_STATUS.requestPending,
        name: 'Заявка от исполнителя ожидает рассмотрения'
    },
    {
        id: ORDER_STATUS.searchable,
        name: 'В поиске исполнителя'
    },
    {
        id: ORDER_STATUS.sentToSignDocuments,
        name: 'Отправлено на подпись документов'
    },
    {
        id: ORDER_STATUS.executorApproved,
        name: 'Исполнитель одобрен'
    },
];

export const ORDER_TYPES = {
    dogWalking: 'dogWalking',
    petBoarding: 'petBoarding',
    petSitting: 'petSitting',
    toSpecialist: 'toSpecialist',
} as const;

export const ORDER_TYPES_OPTIONS = [
    {
        id: ORDER_TYPES.dogWalking,
        name: 'Выгул'
    },
    {
        id: ORDER_TYPES.petBoarding,
        name: 'Передержка'
    },
    {
        id: ORDER_TYPES.petSitting,
        name: 'Няня'
    },
    {
        id: ORDER_TYPES.toSpecialist,
        name: 'Поход к специалисту'
    },
];

export const PET_PLACEMENT = {
    owner: 'owner',
    nanny: 'nanny',
} as const;

export const PET_PLACEMENT_OPTIONS = [
    {
        id: PET_PLACEMENT.owner,
        name: 'У клиента'
    },
    {
        id: PET_PLACEMENT.nanny,
        name: 'У исполнителя'
    },
];

export const WHO_WILL_BRING_PET = {
    im: 'im',
    nanny: 'nanny',
} as const;

export const WHO_WILL_BRING_PET_OPTIONS = [
    {
        id: WHO_WILL_BRING_PET.im,
        name: 'Клиент привезёт питомца'
    },
    {
        id: WHO_WILL_BRING_PET.nanny,
        name: 'Исполнитель заберёт питомца'
    },
];

export const SPECIALIST_TYPE = {
    groomer: 'groomer',
    veterinarian: 'veterinarian',
    other: 'other',
} as const;

export const SPECIALIST_TYPE_OPTIONS = [
    {
        id: SPECIALIST_TYPE.groomer,
        name: 'Грумер'
    },
    {
        id: SPECIALIST_TYPE.veterinarian,
        name: 'Ветеринар'
    },
    {
        id: SPECIALIST_TYPE.other,
        name: 'Другое'
    },
];

export const BASE_PRODUCT_TYPES = [
    PRODUCT_TYPES.dogWalking,
    PRODUCT_TYPES.petBoarding,
    PRODUCT_TYPES.petSitting,
    PRODUCT_TYPES.toSpecialist,
] as const;

export const BASE_PRODUCT_TYPES_OPTIONS = PRODUCT_TYPES_OPTIONS.filter(
    option => BASE_PRODUCT_TYPES.some((type) => type === option.id)
);

export const BLOG_POST_AUDIENCE = {
    client: 'client',
    executor: 'executor',
    all: 'all',
} as const;

export const BLOG_POST_AUDIENCE_OPTIONS = [
    {
        id: BLOG_POST_AUDIENCE.client,
        name: 'Для клиентов'
    },
    {
        id: BLOG_POST_AUDIENCE.executor,
        name: 'Для исполнителей'
    },
    {
        id: BLOG_POST_AUDIENCE.all,
        name: 'Для всех'
    },
];

export const PROMO_CODE_TYPES = {
    percentage: 'percentage',
    fixedAmount: 'fixedAmount',
} as const;

export const PROMO_CODE_TYPES_OPTIONS = [
    {
        id: 'percentage',
        name: 'Процентная'
    },
    {
        id: 'fixedAmount',
        name: 'Фиксированная'
    },
];

export const PROMO_CODE_STATUSES = {
    new: 'new',
    ready: 'ready',
    active: 'active',
    exhausted: 'exhausted',
    blocked: 'blocked',
} as const;

export const PROMO_CODE_STATUSES_OPTIONS = [
    {
        id: 'new',
        name: 'Новый'
    },
    {
        id: 'ready',
        name: 'Готов к выдаче'
    },
    {
        id: 'active',
        name: 'Активен'
    },
    {
        id: 'exhausted',
        name: 'Погашен'
    },
    {
        id: 'blocked',
        name: 'Заблокирован'
    },
];
